import { Loader2 } from "lucide-react";
import { cn } from "src/utilities/shadcnUtils";

export interface CircleSpinnerProps {
  className?: string;
}

const CircleSpinner = ({ className }: CircleSpinnerProps) => (
  <Loader2 className={cn("w-8 h-8 animate-spin text-muted-foreground", className)} />
);

export default CircleSpinner;
